"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = exports.Tags = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _globals = require("@insided/shared/utils/globals");

var _trackingLink = _interopRequireDefault(require("../link/tracking-link"));

var _searchClientProvider = _interopRequireDefault(require("../search/searchClientProvider"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'tag_cloud';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-tag_cloud';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  title: _zod.z.string(),
  amount: _zod.z.number()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var Tags = /*#__PURE__*/function (_ComponentWithSearchC) {
  (0, _inherits2.default)(Tags, _ComponentWithSearchC);

  var _super = _createSuper(Tags);

  function Tags() {
    (0, _classCallCheck2.default)(this, Tags);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Tags, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tags = _this$props.tags,
          config = _this$props.config;
      var classNames = 'widget--tags qa-widget-popular-subjects';
      if (!tags.length) return null;
      return (0, _preact.h)(_widgetContainer.default, {
        widgetName: widgetName,
        config: config,
        className: classNames
      }, (0, _preact.h)(_trackingLink.default, {
        tag: "ul",
        track: {
          type: 'Sidebar Widget Clicked',
          widget: 'tag cloud'
        },
        gaEvents: {
          eventCategory: 'Homepage',
          eventAction: 'Widget Clicked',
          eventLabel: {
            Type: 'tagcloud'
          }
        },
        className: (0, _classnames.default)('public-tags', 'list', 'list--float', 'js-collapsable--content', 'qa-tags-list')
      }, tags.map(function (tag) {
        return (0, _preact.h)("li", {
          key: tag
        }, (0, _preact.h)("a", {
          className: "tag--pill qa-tag-pill",
          href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/search/index?q=").concat(encodeURIComponent(tag), "&search_type=tag"))
        }, tag));
      })));
    }
  }]);
  return Tags;
}(_searchClientProvider.default);

exports.Tags = Tags;

var WidgetPopularTags = /*#__PURE__*/function (_ComponentWithSearchC2) {
  (0, _inherits2.default)(WidgetPopularTags, _ComponentWithSearchC2);

  var _super2 = _createSuper(WidgetPopularTags);

  function WidgetPopularTags(props) {
    var _this;

    (0, _classCallCheck2.default)(this, WidgetPopularTags);
    _this = _super2.call(this, props);
    _this.state = {
      tags: []
    };
    return _this;
  }

  (0, _createClass2.default)(WidgetPopularTags, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _get2.default)((0, _getPrototypeOf2.default)(WidgetPopularTags.prototype), "componentDidMount", this).call(this);

              case 2:
                if (this.algoliaIndex) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return this.algoliaIndex.searchForFacetValues({
                  maxFacetHits: this.props.amount,
                  facetName: 'tags',
                  facetingAfterDistinct: true,
                  facetQuery: ''
                });

              case 6:
                result = _context.sent;
                this.setState({
                  tags: result.facetHits.map(function (_ref) {
                    var value = _ref.value;
                    return value;
                  })
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      return (0, _preact.h)(Tags, {
        config: this.props.config,
        tags: this.state.tags
      });
    }
  }]);
  return WidgetPopularTags;
}(_searchClientProvider.default);

exports.default = WidgetPopularTags;